import "./index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import LolaWidget from "./components/LolaWidget";
import LolaConcierge from "./components/LolaConcierge";
import Footer from "./components/Footer";
import Gateway from "./pages/Gateway";
import Advisory from "./pages/Advisory";
import Diagnostic from "./pages/Diagnostic";
import Results from "./pages/Results";
import Experiences from "./pages/Experiences";
import WellthspanIndex from "./pages/WellthspanIndex";
import ExperienceDetail from "./pages/ExperienceDetail";
import ListHome from "./pages/ListHome";
import Dashboard from "./pages/Dashboard";
import LeverageDetail from "./pages/LeverageDetail";
import Opportunities from "./pages/Opportunities";
import PublicProfile from "./pages/PublicProfile";
import Auth from "./pages/Auth";
import Payment from "./pages/Payment";
import Founder from "./pages/Founder";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import Speakers from "./pages/Speakers";
import Contribution from "./pages/Contribution";
import Contact from "./pages/Contact";
import Welcome from "./pages/Welcome";
import Leads from "./pages/Leads";
import Privacy from "./pages/Privacy";

const PORTAL = ["/list/dashboard", "/list/leverage", "/list/opportunities", "/list/profile", "/login", "/admin"];
function LolaGate() {
  const { pathname } = useLocation();
  if (PORTAL.some((p) => pathname.startsWith(p))) return pathname.startsWith("/admin") ? null : <LolaWidget mode="list" />;
  return <LolaConcierge />;
}

function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return; }
    let tries = 0;
    const t = setInterval(() => {
      const el = document.getElementById(hash.slice(1));
      if (el || ++tries > 30) {
        clearInterval(t);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 900);
        }
      }
    }, 100);
    return () => clearInterval(t);
  }, [pathname, hash]);
  return null;
}

function Reveal() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add("rv-in"); io.unobserve(e.target); }
    }), { threshold: 0, rootMargin: "0px 0px -4% 0px" });
    const scan = () => document.querySelectorAll("section h1, section h2, section h3, section p, section img").forEach((el) => {
      if (el.classList.contains("rv-in") || el.closest("header, footer, [data-noreveal], [data-testid=invite-modal]")) return;
      el.classList.add("rv");
      io.observe(el);
    });
    scan();
    const t1 = setTimeout(scan, 900);
    const t2 = setTimeout(scan, 2200);
    const t3 = setTimeout(() => document.querySelectorAll(".rv:not(.rv-in)").forEach((el) => { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add("rv-in"); }), 3000);
    return () => { io.disconnect(); clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [pathname]);
  return null;
}

function FooterGate() {
  const { pathname } = useLocation();
  const hidden = ["/diagnostic", "/login", "/payment/success"];
  if (hidden.includes(pathname)) return null;
  return <Footer />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" />
        <ScrollToHash />
        <Reveal />
        <Routes>
          <Route path="/" element={<Gateway />} />
          <Route path="/advisory" element={<Advisory />} />
          <Route path="/founders" element={<Founder />} />
          <Route path="/founder" element={<Navigate to="/founders" replace />} />
          <Route path="/speakers" element={<Speakers />} />
          <Route path="/contribution" element={<Contribution />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/admin/leads" element={<Leads />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/diagnostic" element={<Diagnostic />} />
          <Route path="/diagnostic/results" element={<Results />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/wellthspan" element={<WellthspanIndex />} />
          <Route path="/experiences/:slug" element={<ExperienceDetail />} />
          <Route path="/list" element={<ListHome />} />
          <Route path="/list/dashboard" element={<Dashboard />} />
          <Route path="/list/leverage/:id" element={<LeverageDetail />} />
          <Route path="/list/opportunities" element={<Opportunities />} />
          <Route path="/list/profile/:id" element={<PublicProfile />} />
          <Route path="/list/membership" element={<Navigate to="/list#the-list" replace />} />
          <Route path="/connectivity" element={<Navigate to="/list" replace />} />
          <Route path="/login" element={<Auth />} />
          <Route path="/payment/success" element={<Payment />} />
        </Routes>
        <FooterGate />
        <LolaGate />
      </BrowserRouter>
    </AuthProvider>
  );
}
